export default __webpack_public_path__ + "static/Klauzula informacyjna dot. przetwarzania danych osobowych w procesie AML.pdf";